import React from 'react';
import { useSelector } from "react-redux";

import { ToastWithTime, ToastTypeWithId } from './';


interface StateProps {
  toasts: AppState["toasts"]["list"]
}

interface AppState {
  toasts: {
    list: ToastTypeWithId[]
  }
}

const mapStateToProps: (state: AppState) => StateProps =
  (state) => {
    return {
      toasts: state.toasts.list
    };
  }

interface ownProps {
  del_toast_action: (id: number) => void
}


const ToastFeed = ({ del_toast_action }: ownProps) => {
  const toasts = useSelector(mapStateToProps);
  return (
    <div
      aria-live="polite" aria-atomic="true"
      style={{ position: 'fixed', top: 55, right: 0, zIndex: 100000, }}
      className="mt-2 mr-2 ml-2"
    >
      <div style={{ position: 'relative', top: 0, right: 0 }} >
        {
          toasts.toasts.map((item: ToastTypeWithId) => {
            return <ToastWithTime
              key={item.id}
              del_toast_action={del_toast_action}
              {...item}
            />;
          })
        }
      </div>
    </div >
  );
}

export default ToastFeed;
